import { Box, Typography, Chip } from "@mui/material";
import { PipelinePickup } from "../types";

type Props = {
  recommendation: NonNullable<PipelinePickup["autoRecommendation"]>;
};

export function NewOrderCardContent({ recommendation }: Props) {
  return (
    <Box
      sx={{
        mt: 1.5,
        p: 1.5,
        backgroundColor: "#F0F7FF",
        border: "1px solid #BBDEFB",
        borderRadius: "8px",
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        fontWeight={700}
        letterSpacing={0.8}
        display="block"
        sx={{ fontSize: 10, mb: 0.75 }}
      >
        AUTO-RECOMMENDATION
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        <Typography variant="body2" fontWeight={600} sx={{ fontSize: 13 }}>
          {recommendation.vendorName}
        </Typography>
        {recommendation.instantBook && (
          <Chip
            label="INSTANT BOOK"
            size="small"
            sx={{
              height: 20,
              fontSize: 9,
              fontWeight: 700,
              letterSpacing: 0.3,
              borderRadius: "4px",
              backgroundColor: "#E8F5E9",
              color: "#2E7D32",
            }}
          />
        )}
      </Box>
      <Typography variant="body2" color="text.secondary" mt={0.5} sx={{ fontSize: 13 }}>
        {recommendation.priceLabel}
      </Typography>
    </Box>
  );
}
